module.exports = __webpack_public_path__ + "static/img/nodata-tip.d752693c.png";